/**
 * Format phone number to include country code
 * Automatically adds +254 (Kenya) if no country code is present
 * Handles various input formats:
 * - 0712345678 -> +254712345678
 * - 712345678 -> +254712345678
 * - 254712345678 -> +254712345678
 * - +254712345678 -> +254712345678 (no change)
 */
export function formatPhoneNumber(phone) {
  if (!phone) return '';
  
  // Remove all spaces, dashes, and other non-digit characters except +
  let cleaned = phone.replace(/[\s\-()]/g, '');
  
  // If already starts with +, keep it
  if (cleaned.startsWith('+')) {
    return cleaned;
  }
  
  // If starts with 254 (country code without +), add +
  if (cleaned.startsWith('254') && cleaned.length >= 12) {
    return '+' + cleaned;
  }
  
  // If starts with 0 (local format like 0712345678), replace 0 with +254
  if (cleaned.startsWith('0') && cleaned.length === 10) {
    return '+254' + cleaned.substring(1);
  }
  
  // If it's 9 digits (like 712345678), assume it's missing the leading 0 and country code
  if (cleaned.length === 9 && /^[1-9]\d{8}$/.test(cleaned)) {
    return '+254' + cleaned;
  }
  
  // If it's 10 digits starting with 7 (like 7123456780), assume it's missing country code
  if (cleaned.length === 10 && cleaned.startsWith('7')) {
    return '+254' + cleaned;
  }
  
  // Return as is if it doesn't match any pattern
  return cleaned;
}

/**
 * Clean phone number for validation (remove spaces, dashes, etc.)
 */
export function cleanPhoneNumber(phone) {
  if (!phone) return '';
  return phone.replace(/[\s\-()]/g, '');
}

